var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbBadge',{attrs:{"text":_vm.statusType.text,"type":_vm.statusType.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }